import { ICreateGridFromConfigProps, ISvgWithSize } from "../../types/ICreateBayGridBaseProps";

import { buildGridRowsAndTiers } from "./buildGridRowsAndTiers";
import createBayGrid from "./createBayGrid";

/**
 * Creates a grid (above & below decks) from parameters.
 * Each part omits the centerline row (00) when its own flag (`aboveCenterLineRow` / `belowCenterLineRow`) is off.
 * @returns ISvgWithSize { svg, width, height }
 */
export function createGridFromConfig<U>({
  minAboveTier,
  maxAboveTier,
  minBelowTier,
  maxBelowTier,
  centerLineRow,
  aboveCenterLineRow,
  belowCenterLineRow,
  maxRow,
  ...gridOptions
}: ICreateGridFromConfigProps<U>): ISvgWithSize {
  const minRow = centerLineRow ? 0 : 1;

  if (Number(maxRow) < minRow) {
    throw { message: `tedivoGridFromConfig: maxRow must be >= ${minRow}` };
  }

  const { aboveRowsArray, belowRowsArray, aboveTiersArray, belowTiersArray } =
    buildGridRowsAndTiers({
      minAboveTier,
      maxAboveTier,
      minBelowTier,
      maxBelowTier,
      centerLineRow,
      aboveCenterLineRow,
      belowCenterLineRow,
      maxRow,
    });

  if (aboveTiersArray === undefined && belowTiersArray === undefined) {
    throw { message: `tedivoGridFromConfig: no tiers to draw` };
  }

  return createBayGrid({
    ...gridOptions,
    aboveTiersArray: aboveTiersArray || [],
    belowTiersArray: belowTiersArray || [],
    rowsArray: aboveTiersArray ? aboveRowsArray : belowRowsArray,
    aboveRowsArray,
    belowRowsArray,
  });
}
